import React from "react";
import Button from "@material-ui/core/Button";
// import { withStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
//import MuiDialogTitle from "@material-ui/core/DialogTitle";
//import MuiDialogContent from "@material-ui/core/DialogContent";
// import MuiDialogActions from "@material-ui/core/DialogActions";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

export default function SimpleDialog(props) {
  const { open, handleClose, dataC } = props;
 
   console.log(dataC);
    

  const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  });

  
  const OpenMailTo = (e) => {
    //  debugger;
     window.location.href ='mailto:'+ e.target.id + '?subject=פניה מאתר קבלנים';

}

  // if you want to customize the styling

  // const DialogContent = withStyles(theme => ({
  //   root: {
  //     padding: theme.spacing(2)
  //   }
  // }))(MuiDialogContent);

  // const DialogActions = withStyles(theme => ({
  //   root: {
  //     margin: 0,
  //     padding: theme.spacing(1)
  //   }
  // }))(MuiDialogActions);

  return (
 
    <Dialog style={{direction:'rtl'}}
      onClose={handleClose}
      // aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle>יצירת קשר</DialogTitle>
      <DialogContent dividers>
        <Typography >
         תיאום אספקות:   {dataC != null ? dataC.slp1: ''}  ☎  {dataC != null ? dataC.slp1Phone: ''}
         </Typography>
        <Typography  id={dataC != null ? dataC.slp1Mail: ''} onClick={(e) => OpenMailTo(e)} style={{cursor:'pointer'}}>
         מייל {dataC != null ? dataC.slp1Mail: ''}
        </Typography>
        <Typography  >
         זימון דיירים:  {dataC != null ? dataC.slp2 + ' ☏ ' + dataC.slp2Phone : ''} 
        </Typography>
      </DialogContent>
      {/* autoFocus gutterBottom*/}
      <DialogActions>
        <Button  onClick={handleClose} color="primary">
          אשר
        </Button>
      </DialogActions>
    </Dialog>
  );
}



// export default function SimpleDialogDemo() {
//   const [selectedValue] = React.useState([]);
//   const [open, setOpen] = React.useState(false);

//   const handleOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   return (
//     <div>
//       <Typography variant="subtitle1">{selectedValue}</Typography>
//       <br />
//       <Button onClick={handleOpen} variant="outlined" color="primary">
//         Open simple dialog
//       </Button>
//       <SimpleDialog open={open} handleClose={handleClose} />
//     </div>
//   );
// }
